import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpBetLogFailQueryTotal, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { betRecordSliceActions } from '@/modules/report/slice/betRecord';

export class CMDSpBetLogFailQueryTotalHandler extends AbstractHandler {
    _command: CMDSpBetLogFailQueryTotal;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBetLogFailQueryTotal;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        dispatch(betRecordSliceActions.updateTotal(this._command.TotalRow));
    }
}
